module.exports = __webpack_public_path__ + "img/tag-2.e03f849b.svg";